<template>
<main class="project-page">
  <div class="switcher">
    <router-link :to="{ name: 'project', hash: '' }" :class="{ active: $route.hash == '' }">
      <txt phrase="Images" />
    </router-link>
    <router-link :to="{ name: 'project', hash: '#text' }" :class="{ active: $route.hash == '#text' }">
      <txt phrase="Text" />
    </router-link>
  </div>
  <div v-if="$route.hash == '#images' || $route.hash == ''" class="project-images">
    <siema ref="siema" :loop="true">
      <div class="image-slide" v-for="(file, index) in project.images" :key="index">
        <Vue100vh>
          <img :src=" file.url" :alt="project.title" />
        </Vue100vh>
      </div>
    </siema>
    <div>
      <a class="prev" @click="prev">
        <txt phrase="Previous" />
      </a>
      <a class="next" @click="next">
        <txt phrase="Next" />
      </a>
      <div class="project-title">
        <router-link :to="{ name: 'project', hash: '#text' }" :class="{ active: $route.hash == '#text' }">
          <txt :phrase="project.title" />
        </router-link>
      </div>
    </div>
  </div>
  <div v-else class="project-info">
    <div class="project-title">
      <router-link :to="{ name: 'project', hash: '' }" :class="{ active: $route.hash == '' }">
        <txt :phrase="project.title" />
      </router-link>
    </div>
    <p v-if="project.title">{{ project.year }}</p>
    <p v-if="project.type">{{ project.type | capitalize }}</p>
    <p v-if="project.projectstatus">{{ project.projectstatus | capitalize }}</p>
    <p v-if="project.surface">{{ project.surface }} m2</p>
    <p v-if="project.team">{{ project.team }}</p>
    <div class="project-description" v-html="project.description"></div>
  </div>
</main>
</template>

<script>
import Vue100vh from 'vue-div-100vh'
const Txt = () => import( /* webpackChunkName: "Text" */ '@/components/TableText.vue')
export default {
  name: 'project',
  metaInfo() {
    return {
      title: '– ' + this.project.title,
    }
  },
  components: {
    Txt,
    Vue100vh
  },
  computed: {
    project() {
      return this.$store.getters.getProjectByUID(this.$route.params.id)
    }
  },
  methods: {
    prev() {
      this.$refs.siema.prev();
    },
    next() {
      this.$refs.siema.next();
    },
  }
}
</script>

<style lang="scss" scoped>
.project-page {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.switcher {
    position: absolute;
    top: var(--lh);
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    a:last-of-type {
        margin-left: calc(0.5 * var(--lh));
    }
    @media only screen and (max-width:768px) {
        position: relative;
        left: auto;
        top: auto;
        transform: none;
        padding: 0 var(--lh) var(--lh);
    }
}
.project-images {
    width: 100%;
    height: calc(100% - (2 * var(--lh)));
    .project-title {
        position: absolute;
        bottom: var(--lh);
        cursor: pointer;
    }
    .siema {
        height: calc(100% - (2 * var(--lh)));
        overflow: hidden;
        @media only screen and (min-width:768px) {
            height: 100%;
        }
    }
    .next,
    .prev {
        position: absolute;
        bottom: 0;
        cursor: pointer;
        width: 33%;
        height: calc(100vh - (3 * var(--lh)));
        opacity: 0;
        display: flex;
        align-items: flex-end;
        transition: opacity 0.5s;
        padding: var(--lh);
        &:hover {
            opacity: 1;
        }
    }
    .next {
        right: 0;
        justify-content: flex-end;
        cursor: e-resize;
    }
    .prev {
        left: 0;
        cursor: w-resize;
    }
    @media only screen and (max-width:768px) {
        .next,
        .prev {
            display: none;
        }
    }
    .project-title {
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        @media only screen and (max-width:768px) {
            // left: auto;
            // padding: var(--lh) var(--lh) 0;
            // position: relative;
            // transform: none;
        }
    }
    .image-slide {
        width: 100%;
        height: 100%;
        // height: calc(100vvh - calc(4 * var(--lh)));
        // @media only screen and (max-width:1024px) {
        //     height: calc(100vvh - (5 * var(--lh)));
        // }
        // @media only screen and (max-width:768px) {
        //     height: calc(100vvh - (6 * var(--lh)));
        // }
        text-align: center;
        position: relative;
        padding: 0 var(--lh);
        overflow: hidden;
        img {
            width: auto !important;
            max-width: 100%;
            display: inline-block;
            object-fit: contain;
            position: relative;
            box-sizing: border-box;
            z-index: 1;
            height: calc(100% - (6 * var(--lh)));
            @media only screen and (max-width:1024px) {
                height: calc(100% - (7 * var(--lh)));
            }
            @media only screen and (max-width:768px) {
                height: calc(100% - (9 * var(--lh)));
            }
        }
    }
}
.project-info {
    width: 100%;
    padding: calc(2 * var(--lh)) 20vw;
    margin-bottom: var(--lh);
    @media only screen and (max-width:768px) {
        padding: 0 var(--lh);
        margin-bottom: 0;
    }
    p {
        margin-bottom: 0 !important;
    }
    .project-description {
        margin-top: var(--lh);
        padding-bottom: var(--lh);
    }
}
.project-title {
    margin-bottom: var(--lh);
}
</style>
